import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createProfessional } from 'src/lib/sante-api/professionals'

import { getQueryFromSessionStorage } from './useFetchProfessionalsQuery'

/**
 * @param {import('@tanstack/react-query').UseMutationOptions} options
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
export function useCreateProfessionalMutation(options = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: createProfessional,
    onSettled: () => {
      const queryKey = getQueryFromSessionStorage()

      if (queryKey) queryClient.invalidateQueries({ queryKey })
    },
  })
}
